@import '@helsenorge/designsystem-react/scss/_spacers.scss';

.contactform {
  &__date {
    position: absolute;
    left: -2000px;
  }

  &__help {
    margin-top: getSpacer(l);
    margin-bottom: getSpacer(l);
  }
}
